"use client";
import { useRef, useState } from "react";
function useOptimisticSelection(value, { isControlled, initial, equals = Object.is }) {
    const [optimisticValue, setOptimisticValue] = useState(initial);
    const lastSeenRef = useRef(initial);
    if (isControlled && !equals(value, lastSeenRef.current)) {
        lastSeenRef.current = value;
        setOptimisticValue(value);
    }
    return [
        optimisticValue,
        setOptimisticValue
    ];
}
export { useOptimisticSelection };
